import {
  colorBorderError,
  colorBorderSuccess,
  colorDealBg,
  colorDealBorder,
  colorDealText,
  colorSurfaceError,
  colorSurfaceSuccess,
  colorTextError,
  colorTextSuccess,
} from "src/design/tokens";
import { AccountRequest } from "src/data/admin/queries/accountRequest";

export type RequestStatus = AccountRequest["status"];

export const STATUS_CHIP_STYLES: Record<
  RequestStatus,
  { bg: string; color: string; border: string }
> = {
  PENDING: { bg: colorDealBg, color: colorDealText, border: colorDealBorder },
  APPROVED: {
    bg: colorSurfaceSuccess,
    color: colorTextSuccess,
    border: colorBorderSuccess,
  },
  REJECTED: {
    bg: colorSurfaceError,
    color: colorTextError,
    border: colorBorderError,
  },
};

export const STATUS_LABELS: Record<RequestStatus, string> = {
  PENDING: "Pending",
  APPROVED: "Approved",
  REJECTED: "Rejected",
};

export const formatRequestDate = (iso: string) => {
  const d = new Date(iso);
  return d.toLocaleDateString("fr-FR", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
  });
};
